import { FeatureName } from '@bybeam/platform-types';
import useClaim from '@platform-ui/claim/hooks/useClaim.js';
import { W9Form } from '@platform-ui/claim/pages/index.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';

export function ClaimFundsW9(): JSX.Element {
  const necessaryFeatures = [FeatureName.TaxFormsW9Collection, FeatureName.PaymentsClaimFunds];
  const { method, fulfillmentId, getNextPage } = useClaim();
  const redirectToUrl = makeRoute(getNextPage(method), { fulfillmentId });
  return <W9Form necessaryFeatures={necessaryFeatures} redirectToUrl={redirectToUrl} />;
}
